import { render, staticRenderFns } from "./SubdivisionCreatePage.vue?vue&type=template&id=64305ba2"
import script from "./SubdivisionCreatePage.vue?vue&type=script&lang=js"
export * from "./SubdivisionCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports